.loader{position:absolute;width:100%;top:0;left:0;z-index:500000;transition:opacity .3s ease;opacity:0;pointer-events:none}.loader.show{opacity:1}.loader .progress-bar{width:100%}
/*# sourceMappingURL=loader.component-5LRGEQCT.css.map */
